module.exports = __webpack_public_path__ + "static/media/x.f3e9efc1.svg";